import guidesFetch from './guides-fetch';

document.querySelectorAll( '.b-guides' ).forEach( ( block ) => {

	guidesFetch( block );

} );
